import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { Flowbite } from "flowbite-react";

import reportWebVitals from "./reportWebVitals";
import { router } from "./router";
import {
  AuthProvider,
  ToastProvider,
  FeatureFlagsProvider,
  OwnerScopeProvider,
  IntegrationsProvider,
} from "./contexts";
import { ImpersonationBanner } from "./components";
import { initPostHog } from "./utils/posthog";

import "./index.css";
import "./i18n";

// Custom Flowbite theme for high z-index tooltips
const flowbiteTheme = {
  tooltip: {
    target: "",
    animation: "transition-opacity",
    arrow: {
      base: "absolute z-10 h-2 w-2 rotate-45",
      style: {
        light: "bg-white",
        dark: "bg-gray-900",
        auto: "bg-white dark:bg-gray-700",
      },
      placement: "-4px",
    },
    base: "absolute z-[9999] inline-block rounded-lg px-3 py-2 text-sm font-medium shadow-sm",
    hidden: "invisible opacity-0",
    style: {
      light: "border border-gray-200 bg-white text-gray-900",
      dark: "bg-gray-900 text-white",
      auto: "border border-gray-200 bg-white text-gray-900 dark:border-none dark:bg-gray-700 dark:text-white",
    },
    content: "relative z-20",
  },
};

// Suppress ResizeObserver loop error - this is a browser quirk, not a real issue
// https://github.com/WICG/resize-observer/issues/38
if (typeof window !== "undefined") {
  const debounce = (fn, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => fn(...args), delay);
    };
  };

  const OriginalResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
    constructor(callback) {
      super(debounce(callback, 20));
    }
  };
}

// Initialize PostHog analytics
initPostHog();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Flowbite theme={{ theme: flowbiteTheme }}>
      <ToastProvider>
        <AuthProvider>
          <FeatureFlagsProvider>
            <IntegrationsProvider>
              <OwnerScopeProvider>
                <ImpersonationBanner />
                <RouterProvider router={router} />
              </OwnerScopeProvider>
            </IntegrationsProvider>
          </FeatureFlagsProvider>
        </AuthProvider>
      </ToastProvider>
    </Flowbite>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
